import React from 'react';
import GoogleCustomSearch from './GoogleCustomSearch';

interface SearchBarProps {
  language?: string;
}

const SearchBar: React.FC<SearchBarProps> = ({ language }) => {

  return (
    <div style={{ textAlign: 'center', marginTop: '10px'}}>
      <GoogleCustomSearch language={language}/>
    </div>
  );
};

export default SearchBar;